import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { isCoastalMaritimeDomainId } from "@/lib/maritime-domains";
import {
  mapApiMaritimeArea,
  type MaritimeArea,
} from "@/features/dashboard/components/warnings/maritime-areas.utils";

export type { MaritimeArea } from "@/features/dashboard/components/warnings/maritime-areas.utils";
export type { MaritimeWarningDomainId } from "@/lib/maritime-domains";

/** Coastal districts only — used by the maritime forecast widget (coastal forecast domain). */
export function isCoastalMaritimeArea(area: MaritimeArea): boolean {
  return isCoastalMaritimeDomainId(area.domainId);
}

export const maritimeAreasQueryKey = ["maritimeWarnings", "areas"] as const;

async function fetchMaritimeAreas(): Promise<MaritimeArea[]> {
  const { data } = await api.data.listMaritimeAreas();
  return (data ?? []).map(mapApiMaritimeArea);
}

export const maritimeAreasQuery = () =>
  ({
    queryKey: maritimeAreasQueryKey,
    queryFn: fetchMaritimeAreas,
  }) as const;

export const useMaritimeAreasQuery = (options?: { enabled?: boolean }) =>
  useQuery({
    ...maritimeAreasQuery(),
    enabled: options?.enabled ?? true,
  });
